import React from "react";

import TurnstileWidget from "./TurnstileWidget";
import { isTurnstileEnabled } from "./turnstile";

type UseTurnstileVerificationParams = {
  action: string;
};

function useTurnstileVerification(
  params: UseTurnstileVerificationParams
) {
  const { action } = params;
  const [token, setToken] = React.useState<string | null>(null);
  const [resetKey, setResetKey] = React.useState(0);

  const resetVerification = React.useCallback(() => {
    setToken(null);
    setResetKey((current) => current + 1);
  }, []);

  return {
    token,
    disableSubmit: isTurnstileEnabled() && !token,
    resetVerification,
    widget: (
      <TurnstileWidget
        action={action}
        onTokenChange={setToken}
        resetKey={resetKey}
      />
    ),
  };
}

export default useTurnstileVerification;
